// import userService from '../../../contextAPI/user/services/user.service';
import { BasicInfo, SortDirection } from '../../../../utils/types/types';
import { BaseLandscapeServiceV3 } from '../../base-landscape.service-v3';
import { SortBy } from '../dto/request/all-landscapes.dto';
import { UpdateInitiativeDto } from '../dto/request/update-initiative-dto';
import { LandscapeResponseV3Dto } from '../dto/response/landscape-response-v3.dto';
import { LandscapesResponseV3Dto } from '../dto/response/landscapes-response-v3.dto';

class LandscapeServiceV3 extends BaseLandscapeServiceV3 {
  public async fetchLandscapes(
    page: number = 1,
    pageSize: number = 10,
    sortBy: SortBy = 'name',
    sortDirection: SortDirection = 'asc'
  ): Promise<LandscapesResponseV3Dto> {
    const response = await this.get<LandscapesResponseV3Dto>(
      `/initiatives/back-office?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDirection=${sortDirection}`
    );

    return response.data;
  }

  public async deleteLandscape(initiativeId: string): Promise<void> {
    await this.delete<void>(`/initiatives/${initiativeId}`);
  }

  public async fetchLandscapeById(initiativeId: string): Promise<any> {
    const response = await this.get<LandscapeResponseV3Dto>(
      `/initiatives/back-office/${initiativeId}`
    );

    return response.data;
  }

  public async saveLandscape(landscape: any): Promise<any> {
    const response = await this.post<any>(
      '/initiatives/back-office',
      landscape
    );

    return response.data;
  }

  public async editLandscape(
    landscape: UpdateInitiativeDto,
    languageCode: string,
    translateToAllLanguages: boolean = false
  ): Promise<any> {
    const response = await this.put<any>(
      `/initiatives/back-office?languageCode=${languageCode}&translateToAllLanguages=${translateToAllLanguages}`,
      landscape
    );

    return response.data;
  }

  public async getLandscapes(): Promise<BasicInfo[]> {
    const response = await this.get<BasicInfo[]>('/initiatives/base-info');

    return response.data;
  }
}
const landscapeServiceV3 = new LandscapeServiceV3();
export default landscapeServiceV3;
